module.exports = __webpack_public_path__ + "img/scene2-0.afdb3ab4.jpg";